<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <!-- <div class="collapse-btn">
			<i v-if="!collapse" class="el-icon-s-fold"></i>
			<i v-else class="el-icon-s-unfold"></i>
		</div> -->
    <div class="collapse-box">
      <div class="collapse-img">
        <img
          class="collapse-btn activeImg"
          :src="logoImg"
          alt=""
          @click="collapseChage"
        />
      </div>
    </div>

    <div>
      <div class="logo">企业运营中心</div>
      <div class="header-right">
        <div class="header-user-con">
          <!-- 全屏显示 -->
          <!-- <div class="btn-fullscreen" @click="handleFullScreen">
					<el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
						<i class="el-icon-rank" style='color: #333;'></i>
					</el-tooltip>
				</div> -->
          <!-- 用户头像 -->
          <!-- <div class="user-avator">
					<img src="../../assets/img/img.jpg" />
				</div> -->
          <!-- 用户名下拉菜单 -->
          <!-- <el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
						{{username}}
						<i class="el-icon-caret-bottom"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->
          <div
            v-if="userInfo.purchaseAreaFlag"
            class="kefu"
            style="margin-right: 30px"
            @mousemove="mallMouse"
            @mouseout="mallMouseout"
            @click="goPath"
          >
            <eui-icon :icon="icon" color="#C5C5C5" font-size="20px" />
            <p>企业商城</p>
          </div>
          <div class="kefu" @click="handleCustomer">
            <img src="../../assets/img/home/kefu.png" alt="" />
            <p>{{ userInfo.purchaseAreaFlag ? '小派专服' : '在线客服' }}</p>
          </div>
          <div
            :class="[isShow ? 'user-message-hidden' : 'user-message-show']"
            @click="handleMessage"
          >
            <i
              class="el-icon-message-solid"
              :style="{ color: isShow ? '#888888' : '#d9d9d9' }"
            ></i>
          </div>
          <div
            class="message-content"
            :style="{ display: isShow ? 'block' : 'none' }"
          >
            <div
              v-for="item in tableList"
              :key="item.moduleBelong"
              class="message-list"
            >
              <div class="message-li" @click="handleSkipMessage(item)">
                <span style="color: #333333">{{ item.label }}</span>
                <span style="color: #ef4c56">{{
                  item.count > 9999 ? '9999+' : item.count
                }}</span>
              </div>
            </div>
          </div>
          <div ref="attrRef" class="user-name-wrap">
            <div class="user-name">
              <span>{{ username }}</span>
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="dropdown-wrap">
              <div class="info-img">
                <img
                  v-if="memberIdentity == 'purchase' ? true : false"
                  src="../../assets/img/icon-purchase.png"
                  alt=""
                />
                <img
                  v-if="memberIdentity == 'supplier' ? true : false"
                  src="../../assets/img/icon-supplier.png"
                  alt=""
                />
                <img
                  v-if="memberIdentity == 'double_identity' ? true : false"
                  class="double_identity"
                  src="../../assets/img/caigong.svg"
                  alt=""
                />
              </div>
              <div class="info-box">
                <div>hi,{{ username }}</div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="companyName"
                  placement="left"
                >
                  <div class="ellipsis company_name">{{ companyName }}</div>
                </el-tooltip>
                <div
                  v-if="companyList.length > 1"
                  class="pointer select_company"
                  @click="showDialog"
                >
                  切换公司
                </div>
                <div class="pointer longOut" @click="longOut">退出</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <switch-company
      dialog-title="选择公司"
      :center-dialog-visible="dialogVisible"
      :popup-width="'580px'"
      :show-btn="false"
      @updateVisible="dialogVisible = false"
      @resetPopupData="dialogVisible = false"
    >
      <div class="company-list">
        <ul>
          <li v-for="item in companyList" :key="item.companyId">
            <div>
              <img
                v-if="currentCompanyId == item.companyId"
                src="../../assets/img/icon-choice.png"
                alt=""
              />
              <img v-else src="../../assets/img/icon-unchoice.png" alt="" />

              <span class="company-name">{{ item.companyName }}</span>
            </div>
            <span
              class="pointer"
              :class="{ active: currentCompanyId == item.companyId }"
              @click="choiceCompany(item.companyId)"
            >
              选择公司
            </span>
          </li>
        </ul>
      </div>
    </switch-company>
    <!-- 新手指引 -->
    <frist-guide v-show="show_lib_data == '1' && showGuideType"></frist-guide>
    <second-guide
      v-show="show_lib_data == '2' && showGuideType"
      :menu-name-width="menuNameWidth"
    ></second-guide>
    <third-guide
      v-show="show_lib_data == '3' && showGuideType"
      :menu-name-width="menuNameWidth"
    ></third-guide>
    <fourth-guide v-show="show_lib_data == '4' && showGuideType"></fourth-guide>
    <!-- 合规承诺协议1 -->
    <compliance-commitment
      :compliance-data="complianceData"
    ></compliance-commitment>
    <!-- 安全责任 -->
    <safetyResponsibilityBook
      :dialog-visible="safeVisible"
      :content="dialogIndexINfo[safeDialogType]"
      :type="safeDialogType"
      title=""
      @change="showNextSafeDialog"
    ></safetyResponsibilityBook>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import {
  purchaseUrl,
  callBackUrl,
  gateway,
} from '@/modules/projectA/api/config';

import { dialogIndexINfo } from '@/assets/js/companyFilter';

import switchCompany from './epecDialog.vue';
import api from '../../modules/projectA/api/login';
import api2 from '../../modules/projectA/api/user';
import cmsOssApi from '../../modules/projectA/api/cms-oss/index.js';
import {
  setQimoClientId,
  initSource,
} from '../../modules/projectA/utils/onlineService';
import bus from './bus';
import FristGuide from '../noviceGuide/firstGuide.vue';
import SecondGuide from '../noviceGuide/secondGuide.vue';
import ThirdGuide from '../noviceGuide/thirdGuide.vue';
import FourthGuide from '../noviceGuide/fourthGuide.vue';
import complianceCommitment from './complianceCommitment';
import safetyResponsibilityBook from './safetyResponsibilityBook.vue';
// import listFilterVue from '../../../../epec-mall/components/product/productList/listFilter.vue'
export default {
  components: {
    switchCompany,
    FristGuide,
    SecondGuide,
    ThirdGuide,
    FourthGuide,
    complianceCommitment,
    safetyResponsibilityBook,
  },
  data() {
    return {
      dialogIndexINfo,
      safeDialogType: 'safePopupWindow', // safePopupWindow  promisePopupWindow
      safeVisible: false,
      safeDialogList: [],
      icon: 'eicon-qysc-selected',
      dialogVisible: false,
      collapse: false,
      fullscreen: false,
      username: '',
      companyName: '',
      gateway: `${gateway}/ssoLogin/callback?from=CORP_WEB_SITE`,
      afterLoginUrl: `&afterLoginUrl=${callBackUrl}`,
      memberIdentity: '',
      companyList: [], // 公司列表
      currentCompanyId: '', // 当前公司id
      isShow: false,
      logoImg: require('../../assets/img/bg.png'),
      tableList: [
        {
          label: '采购订单提示',
          count: 0,
          moduleBelong: 'purchaseOrder',
        },
        {
          label: '销售订单提示',
          count: 0,
          moduleBelong: 'supplierOrder',
        },
        {
          label: '协议提示',
          count: 0,
          moduleBelong: 'agreement',
        },
        // {
        //   label: '采购专属区提示',
        //   count: 0,
        //   moduleBelong: 'order'
        // },
        {
          label: '商品提示',
          count: 0,
          moduleBelong: 'product',
        },
        {
          label: '销售商城提示',
          count: 0,
          moduleBelong: 'shop',
        },
        // {
        //   label: '系统通知',
        //   count: 0,
        //   moduleBelong: 'system'
        // },
      ],
      userIdentity: '',
      supplierList: [
        {
          label: '订单提示',
          count: 0,
          moduleBelong: 'supplierOrder',
        },
        {
          label: '协议提示',
          count: 0,
          moduleBelong: 'agreement',
        },
        {
          label: '商品提示',
          count: 0,
          moduleBelong: 'product',
        },
        {
          label: '销售商城提示',
          count: 0,
          moduleBelong: 'shop',
        },
        // {
        //   label: '系统通知',
        //   count: 0,
        //   moduleBelong: 'system'
        // }
      ],
      purchaseList: [
        {
          label: '订单提示',
          count: 0,
          moduleBelong: 'purchaseOrder',
        },
        {
          label: '协议提示',
          count: 0,
          moduleBelong: 'agreement',
        },
        // {
        //   label: '采购专属区提示',
        //   count: 0,
        //   moduleBelong: 'order'
        // },
        // {
        //   label: '系统通知',
        //   count: 0,
        //   moduleBelong: 'system'
        // }
      ],
      showGuideType: false,
      menuNameWidth: null,
      show_lib_data: null,
      complianceData: {},
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.USERINFO;
    },
    show_lib_index() {
      return this.$store.state.showLib;
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(newval) {
        if (newval.realName) {
          this.username = newval.realName;
          this.companyName = newval.companyName;
          this.memberIdentity = newval.memberIdentity;
          this.queryEaUnreadCount();
          this.getOssTemplate();
          this.checkShowGuide();
        }
        const token = this.$cookies.get('epecToken');
        const { companyId } = newval;
        if (token && companyId) {
          this.getCompliance();
        }
      },
    },
    show_lib_index: {
      immediate: true,
      handler(newVal) {
        this.show_lib_data = newVal;
      },
    },
  },
  mounted() {
    initSource();
    const that = this;
    setTimeout(() => {
      switch (that.$store.state.USERINFO.memberIdentity) {
        case 'supplier':
          that.tableList = that.supplierList;
          break;
        case 'purchase':
          that.tableList = that.purchaseList;
          break;
      }
    }, 300);
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
    this.showGuidFlag();
    this.getmenuNameWidth();
    this.getSafeBookDialog();
    this.queryPurchaseProductRangeSet();
  },
  methods: {
    ...mapMutations(['GET_LOGO_IMG_LIST', 'SHOW_LIB', 'IS_PROTOCOL']),
    mallMouse() {
      this.icon = 'eicon-qysc-selected';
    },
    mallMouseout() {
      this.icon = 'eicon-qysc-unselected';
    },
    goPath() {
      window.open(purchaseUrl, '_blank');
    },
    // 采购产品范围
    async queryPurchaseProductRangeSet() {
      const res = await api2.queryPurchaseProductRangeSet();
      if (res.code === '200') {
        this.IS_PROTOCOL(res.data.data);
      }
    },
    handleCustomer() {
      // eslint-disable-next-line no-undef
      if (typeof qimoChatLoaded !== 'undefined' && qimoChatLoaded == true) {
        setQimoClientId();
        // eslint-disable-next-line no-undef
        qimoChatClick();
      } else {
        this.$message.warning('页面尚未加载完成，请稍候点击咨询');
      }
    },
    // 获取生效中模板
    async getOssTemplate() {
      const params = {
        companyId: this.$store.state.USERINFO.companyId,
        columeId: 4, // 1 首页 2 店铺   3 旗舰店
        shopId: 0,
      };
      const res = await cmsOssApi.getShopTemplateossUrl(params);
      this.GET_LOGO_IMG_LIST(res.data.logoImgList[0]);
      this.logoImg =
        res.data?.logoImgList[0] || require('../../assets/img/bg.png');
    },
    epecLoginUrl() {
      // 解码用 decodeURIComponent(str)
      // 编码用 encodeURIComponent(str)
      return encodeURIComponent(this.gateway + this.afterLoginUrl);
    },

    async longOut() {
      const parmas = {
        callBackUrl: this.epecLoginUrl(),
      };
      const res = await api.mallLoginOut(parmas);
      if (res.code == 200) {
        localStorage.clear();
        sessionStorage.removeItem('isShow_message');
        // sessionStorage.removeItem('defaultAnnouncement')
        this.$cookies.remove('epecToken', '/', 'epec.com');
        this.$cookies.remove('epec-gray-group', '/', 'epec.com');
        window.open(res.data, '_self');
      }
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == 'loginout') {
        this.longOut();
      }
      if (command == 'updatePwd') {
        this.$router.push('/updatePwd');
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 全屏事件
    handleFullScreen() {
      const element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
      }
      this.fullscreen = !this.fullscreen;
    },
    showDialog() {
      this.dialogVisible = true;
      this.getCompanyList();
    },
    // 切换公司
    async getCompanyList() {
      const res = await api.getCompanyList();
      this.companyList = res.data;
    },
    async choiceCompany(id) {
      this.currentCompanyId = id;
      const res = await api.switchCompany({ companyId: id });
      if (res.code == 200) {
        this.$router.go(0);
      }
    },

    // 点击查看消息
    handleMessage() {
      this.isShow = !this.isShow;
      this.queryEaUnreadCount();
    },

    // 点击跳转对应的消息页面
    handleSkipMessage(item) {
      this.isShow = false;
      const { moduleBelong } = item;
      // if (item.moduleBelong == 'purchaseOrder' || item.moduleBelong == 'supplierOrder') {
      //   moduleBelong = 'order'
      // } else {
      //   moduleBelong = item.moduleBelong;
      // }
      this.$store.dispatch('moduleBelong', { moduleBelong });
      this.$router.push({
        name: 'systemMessages',
        params: {
          label: item.label,
          moduleBelong,
        },
      });
    },

    async queryEaUnreadCount() {
      const res = await api2.queryEaUnreadCount();
      this.tableList.forEach((item) => {
        let str = '';
        if (
          item.moduleBelong == 'purchaseOrder' ||
          item.moduleBelong == 'supplierOrder'
        ) {
          str = 'order';
        } else {
          str = item.moduleBelong;
        }
        res.data &&
          res.data.forEach((item2) => {
            if (str == item2.moduleBelong) {
              item.count = item2.count;
            }
          });
      });
    },
    // 获得用户是否展示新手引导
    async showGuidFlag() {
      const result = await api2.noviceGuidance();
      if (result.code === '200') {
        if (!result.data.stagingFlag) {
          this.SHOW_LIB('1');
        } else {
          this.SHOW_LIB('-1');
        }
      } else {
        this.SHOW_LIB('-1');
      }
    },
    // 合规承诺-系统弹框
    async getCompliance() {
      const res = await api2.checkAgreementConformance();
      console.log(res);
      if (res.code === '200') {
        this.complianceData = res.data || {};
      }
    },
    next() {
      const nextNum = (parseInt(this.show_lib_index) + 1).toString();
      this.SHOW_LIB(nextNum);
    },
    pure() {
      const nextNum = (parseInt(this.show_lib_index) - 1).toString();
      this.SHOW_LIB(nextNum);
    },
    checkShowGuide() {
      setTimeout(() => {
        this.showGuideType = true;
      }, 500);
    },
    getmenuNameWidth() {
      this.$nextTick(() => {
        const menuNameWidth = this.$refs.attrRef.offsetWidth;
        this.menuNameWidth = menuNameWidth;
      });
    },
    // 安全责任书
    async getSafeBookDialog() {
      const { data: safePopupWindow } = await api2.memberActionQuery({
        action: 'safePopupWindow',
      });
      if (safePopupWindow) {
        this.safeDialogList.push('safePopupWindow');
      }
      const { data: promisePopupWindow } = await api2.memberActionQuery({
        action: 'promisePopupWindow',
      });
      if (promisePopupWindow) {
        this.safeDialogList.push('promisePopupWindow');
      }
      this.showSafeDialog(this.safeDialogList);
    },
    showSafeDialog(list) {
      if (list.length === 0) {
        return false;
      }
      this.safeDialogType = list[0];
      this.safeVisible = true;
    },
    async showNextSafeDialog(item) {
      // console.log(item)
      this.safeDialogList.shift();
      this.safeVisible = false;
      const { success } = await api2.memberActionSave({
        action: item,
        value: 'hidden',
      });
      if (success) {
        if (this.safeDialogList.length === 0) {
          return false;
        }
        this.showSafeDialog(this.safeDialogList);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  font-size: 22px;
  color: #fff;
  /* float: left; */
  background-color: #fff;
}

.collapse-box {
  height: 50px;
  width: 120px;
  display: block;
  float: left;
  cursor: pointer;
}
.activeImg {
  display: block;
  // height: 50px;
  width: 120px;
}
.collapse-img {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  img {
    max-width: 120px;
  }
}
.collapse-btn {
  text-align: center;
  background-size: cover;
}
.logo-img {
  width: 62px;
  height: 30px;
}

.header .logo {
  float: left;
  width: 250px;
  line-height: 50px;
  color: #333333;

  padding-left: 20px;
}

.header-right {
  float: right;
  // padding-right: 50px;
  margin-right: 10px;
  height: 50px;
  .message-content {
    width: 200px;
    min-height: 148px;
    border: solid 1px #d9d9d9;
    position: absolute;
    top: 50px;
    right: 96px;
    z-index: 31;
    background: #fff;
    box-sizing: border-box;
    padding: 10px 20px 20px;
    .message-list {
      cursor: pointer;
      width: 100%;
      height: 100%;
      .message-li {
        width: 100%;
        height: 32px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .user-message-show {
    cursor: pointer;
    position: relative;
    width: 40px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-message-hidden {
    cursor: pointer;
    position: relative;
    width: 40px;
    height: 53px;
    z-index: 32;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 1px #d9d9d9;
    border-bottom: none;
  }
  .user-name-wrap {
    color: #333;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    .user-name {
      min-width: 80px;
      height: 50px;
      text-align: center;
      padding: 0 10px;
      line-height: 50px;
      span {
        margin-right: 10px;
      }
    }
    &:hover {
      .dropdown-wrap {
        display: flex;
      }
    }
  }
  .dropdown-wrap {
    display: none;
    position: absolute;
    min-width: 230px;
    border: 1px solid #d9d9d9;
    background: #fff;
    z-index: 100;
    right: 0;
    padding: 20px;
    .double_identity {
      width: 60px !important;
      height: 28px !important;
    }
    .info-box {
      display: flex;
      flex-direction: column;
      width: 82%;
      height: 100%;
    }
    .info-img {
      min-width: 18%;
      margin-right: 10px;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    div {
      &:nth-child(1) {
        color: #333;
        margin-bottom: 10px;
        font-size: 14px;
      }
      .company_name {
        width: 128px;
        color: #666;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .select_company {
        color: #126edf;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .longOut {
        color: #126edf;
        font-size: 12px;
        text-align: right;
      }
      &:nth-child(5) {
        text-align: right;
        color: #126edf;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}

.header-user-con {
  display: flex;
  height: 50px;
  align-items: center;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

// .user-name {
// 	margin-left: 10px;
// }

.user-avator {
  margin-left: 20px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #333;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}
.el-dialog__body {
  padding: 0;
}
.company-list {
  ul {
    li {
      padding: 0 20px;
      border-bottom: 1px solid #d9d9d9;
      display: flex;
      height: 50px;
      align-items: center;
      justify-content: space-between;
      div {
        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
        display: flex;
      }
      & > span {
        color: #0064c8;
        font-size: 14px;
        &.active {
          border-bottom: 1px solid #0064c8;
        }
      }
    }
  }
}

.kefu {
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-right: 20px;
  p {
    color: #333;
    font-size: 14px;
    margin-left: 10px;
  }
  img {
    height: 30px;
  }
}
</style>
